// Retro tooltip: a one-sentence hint that pops up next to the element on
// hover or keyboard focus (Windows-style yellow box). The spellbook does not
// use these (it explains itself).
import { cloneElement, useId, useState, type ReactElement } from "react";

interface Props {
  text: string;
  /** Where the box appears relative to the element. */
  side?: "top" | "bottom" | "left" | "right";
  children: ReactElement<{
    "aria-describedby"?: string;
    onPointerEnter?: (e: React.PointerEvent) => void;
    onPointerLeave?: (e: React.PointerEvent) => void;
    onFocus?: (e: React.FocusEvent) => void;
    onBlur?: (e: React.FocusEvent) => void;
  }>;
}

export function Tip({ text, side = "top", children }: Props) {
  const id = useId();
  const [open, setOpen] = useState(false);
  const p = children.props;
  return (
    <span className={`tip-wrap tip-${side}`}>
      {cloneElement(children, {
        "aria-describedby": id,
        onPointerEnter: (e: React.PointerEvent) => {
          if (e.pointerType !== "touch") setOpen(true);
          p.onPointerEnter?.(e);
        },
        onPointerLeave: (e: React.PointerEvent) => {
          setOpen(false);
          p.onPointerLeave?.(e);
        },
        onFocus: (e: React.FocusEvent) => {
          setOpen(true);
          p.onFocus?.(e);
        },
        onBlur: (e: React.FocusEvent) => {
          setOpen(false);
          p.onBlur?.(e);
        },
      })}
      <span id={id} role="tooltip" className={open ? "tip open" : "tip"}>
        {text}
      </span>
    </span>
  );
}
